
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1wo5s_101",
  "button": "awsui_button_vjswe_1wo5s_105",
  "variant-normal": "awsui_variant-normal_vjswe_1wo5s_156",
  "variant-icon": "awsui_variant-icon_vjswe_1wo5s_199",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1wo5s_199",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1wo5s_199",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1wo5s_220",
  "disabled": "awsui_disabled_vjswe_1wo5s_241",
  "variant-primary": "awsui_variant-primary_vjswe_1wo5s_249",
  "variant-link": "awsui_variant-link_vjswe_1wo5s_342",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1wo5s_621",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1wo5s_904",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1wo5s_1002",
  "button-no-text": "awsui_button-no-text_vjswe_1wo5s_1095",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1wo5s_1099",
  "full-width": "awsui_full-width_vjswe_1wo5s_1102",
  "icon-left": "awsui_icon-left_vjswe_1wo5s_1121",
  "icon-right": "awsui_icon-right_vjswe_1wo5s_1126",
  "icon": "awsui_icon_vjswe_1wo5s_1121"
};
  